import { render, staticRenderFns } from "./code113.vue?vue&type=template&id=a890fb8e&scoped=true"
import script from "./code113.vue?vue&type=script&lang=js"
export * from "./code113.vue?vue&type=script&lang=js"
import style0 from "./code113.vue?vue&type=style&index=0&id=a890fb8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a890fb8e",
  null
  
)

export default component.exports